export enum IncidentType {
  Merged = 'Merged',
  Duplicate = 'Duplicate',
  Single = 'Single',
}

export const IncidentTypeDescriptor = Object.freeze({
  [IncidentType.Merged]: 'Merged',
  [IncidentType.Duplicate]: 'Duplicate',
  [IncidentType.Single]: 'Single',
});
